<script lang="ts">
  import { router } from './router.svelte';
  import AppSidebar from '@widgets/app-sidebar/AppSidebar.svelte';
  import FirmsPage from '@pages/firms/FirmsPage.svelte';
  import FirmDetailPage from '@pages/firms/FirmDetailPage.svelte';
  import LawyersPage from '@pages/lawyers/LawyersPage.svelte';
  import LawyerDetailPage from '@pages/lawyers/LawyerDetailPage.svelte';
  import ProductsPage from '@pages/products/ProductsPage.svelte';
  import ProductDetailPage from '@pages/products/ProductDetailPage.svelte';
  import FormsPage from '@pages/forms/FormsPage.svelte';
  import FormDetailPage from '@pages/forms/FormDetailPage.svelte';
  import FormSubmissionsPage from '@pages/form-submissions/FormSubmissionsPage.svelte';
  import FormSubmissionDetailPage from '@pages/form-submissions/FormSubmissionDetailPage.svelte';
  import CompetitorServicesPage from '@pages/competitor-services/CompetitorServicesPage.svelte';
  import CompetitorServiceDetailPage from '@pages/competitor-services/CompetitorServiceDetailPage.svelte';
  import ProblemsPage from '@pages/master/problems/ProblemsPage.svelte';
  import ProblemDetailPage from '@pages/master/problems/ProblemDetailPage.svelte';
  import DashboardPage from '@pages/dashboard/DashboardPage.svelte';
  import OrganizationsPage from '@pages/admin/OrganizationsPage.svelte';
  import OrganizationDetailPage from '@pages/admin/OrganizationDetailPage.svelte';
  import MembersPage from '@pages/members/MembersPage.svelte';
  import SiteMembersPage from '@pages/site-members/SiteMembersPage.svelte';

  const WIDE_LIST_ROUTES = new Set([
    'firms-list',
    'lawyers-list',
    'site-members-list',
    'products-list',
    'forms-list',
    'form-submissions-list',
    'third-party-solutions-list',
    'problems-list',
  ]);

  const wide = $derived(WIDE_LIST_ROUTES.has(router.route.name));
</script>

<div class="app-shell">
  <AppSidebar routeName={router.route.name} />
  <main class:wide class="main">
    {#if router.route.name === 'firms-list'}
      <FirmsPage />
    {:else if router.route.name === 'firm-detail'}
      <FirmDetailPage id={router.route.id} />
    {:else if router.route.name === 'lawyers-list'}
      <LawyersPage />
    {:else if router.route.name === 'lawyer-detail'}
      <LawyerDetailPage id={router.route.id} />
    {:else if router.route.name === 'site-members-list'}
      <SiteMembersPage />
    {:else if router.route.name === 'products-list'}
      <ProductsPage />
    {:else if router.route.name === 'product-detail'}
      <ProductDetailPage id={router.route.id} />
    {:else if router.route.name === 'forms-list'}
      <FormsPage />
    {:else if router.route.name === 'form-detail'}
      <FormDetailPage id={router.route.id} />
    {:else if router.route.name === 'form-submissions-list'}
      <FormSubmissionsPage />
    {:else if router.route.name === 'form-submission-detail'}
      <FormSubmissionDetailPage id={router.route.id} />
    {:else if router.route.name === 'third-party-solutions-list'}
      <CompetitorServicesPage />
    {:else if router.route.name === 'third-party-solution-detail'}
      <CompetitorServiceDetailPage id={router.route.id} />
    {:else if router.route.name === 'problems-list'}
      <ProblemsPage />
    {:else if router.route.name === 'problem-detail'}
      <ProblemDetailPage id={router.route.id} />
    {:else if router.route.name === 'dashboard'}
      <DashboardPage />
    {:else if router.route.name === 'admin-organizations'}
      <OrganizationsPage />
    {:else if router.route.name === 'admin-organization-detail'}
      <OrganizationDetailPage id={router.route.id} />
    {:else if router.route.name === 'members'}
      <MembersPage />
    {:else}
      <section class="not-found">
        <h1>Not Found</h1>
        <p>このページは存在しません。<a href="/firms">一覧へ戻る</a></p>
      </section>
    {/if}
  </main>
</div>

<style>
  /* レイアウト本体 (.app-shell, .sidebar, .main) は app.css のグローバル定義に集約。
     ここではこの App.svelte に固有の見た目だけを scoped で持つ。 */
  .not-found {
    text-align: center;
    color: var(--muted);
    padding: 48px 0;
  }
</style>
